import axios from 'axios';
import { API_URL } from '../constantes/constantes';

export async function postToken({user_id}) {
    const BASE_PATH = API_URL;
    let apiURL = `${BASE_PATH}generate-token`;
    
    const data = {
        user_id
    };

    const config = {
        method: 'post',
        url: apiURL,
        timeout: 25000,
        headers: {
            'Accept': 'application/json, text/plain, */*',
            'Content-Type': 'application/json; charset=utf-8'
        },
        data: data // Pasar los datos en el cuerpo de la solicitud
    };

    try {
        const response = await axios(config);

        if (response.status === 200) {
            return { data: response.data, statusCode: 200 };
        } else if (response.status === 404) {
            // Recurso no encontrado
            return { statusCode: 404, data: [] };
        } else if (response.status === 401) {
            // Recurso no encontrado
            return { statusCode: 401, data: [] };
        } else {
            // Otro código de estado, manejar según sea necesario
            return { statusCode: response.status, data: [] };
        }
    } 
    catch (error) {
        // Manejar errores de la petición
        // console.error("Error en la petición del token:", error);
        return { statusCode: 500, data: [] };
    }
}
